import styled from "@emotion/styled";
import DisplayType from "utils/displayType";
import { useLayoutEffect } from "react";
import { updateTitle } from "utils/commonUtil";
import { useLanguage } from "i18n/LanguageContext";
import { renderText } from "i18n/TranslatedText";
import Footer from "../../component/footer/Footer";
import { ReactComponent as Logo } from "../../assets/logo_blue_school.svg";

const BlueSchool = () => {
  const mode = DisplayType();
  const { t } = useLanguage();

  useLayoutEffect(() => {
    updateTitle(t("program", "blueSchool.pageTitle"));
  }, [t]);

  return (
    <Container>
      <HeaderContainer>
        <Logo className="program__logo" />
        <span
          className={`program__title ${
            mode === "Mobile" ? "font-bold-24" : "font-title"
          }`}
        >
          {t("program", "blueSchool.title")}
        </span>
        <p
          className={`program__description ${
            mode === "Mobile" ? "font-body3" : "font-body2"
          }`}
        >
          {renderText(t("program", "blueSchool.desc"), mode)}
        </p>
      </HeaderContainer>
      <BodyContainer className="limit__body">
        <ProgramDescription>
          <div
            className={`program__description__title ${
              mode === "Mobile" ? "font-sub-title2" : "font-title-en"
            }`}
          >
            {renderText(t("program", "blueSchool.descTitle"), mode)}
          </div>
          <p className={`${mode === "Mobile" ? "font-body3" : "font-body2"}`}>
            {t("program", "blueSchool.descBody1")}
            <br />
            <br />
            {t("program", "blueSchool.descBody2")}
          </p>
        </ProgramDescription>
        <ProgramProcess>
          <div
            className={`program__process__title ${
              mode === "Mobile" ? "font-bold-22" : "font-sub-title"
            }`}
          >
            {t("program", "blueSchool.processTitle")}
          </div>
          <div className={`program__process__row`}>
            <span
              className={`${
                mode === "Mobile" ? "font-bold-16" : "font-bold-18"
              }`}
            >
              {t("program", "blueSchool.descLabel")}
            </span>
            <span
              className={`${mode === "Mobile" ? "font-body3" : "font-body2"}`}
            >
              {t("program", "blueSchool.descValue")}
            </span>
          </div>
          <div className={`program__process__row`} style={{ marginTop: 8 }}>
            <span
              className={`${
                mode === "Mobile" ? "font-bold-16" : "font-bold-18"
              }`}
            >
              {t("program", "blueSchool.targetLabel")}
            </span>
            <span
              className={`${mode === "Mobile" ? "font-body3" : "font-body2"}`}
            >
              {t("program", "blueSchool.targetValue")}
            </span>
          </div>
          <div className="program__process__list">
            <ProgramProcessItem>
              <span
                className={`item__title ${
                  mode === "Mobile" ? "font-body3" : "font-body2"
                }`}
              >
                {t("program", "blueSchool.participantsTitle")}
              </span>
              <span
                className={`item__descrition ${
                  mode === "Mobile" ? "font-body3" : "font-body2"
                }`}
              >
                {t("program", "blueSchool.participantsDesc")}
              </span>
            </ProgramProcessItem>
            <ProgramProcessItem>
              <span
                className={`item__title ${
                  mode === "Mobile" ? "font-body3" : "font-body2"
                }`}
              >
                {t("program", "blueSchool.curriculumTitle")}
              </span>
              <span
                className={`item__descrition ${
                  mode === "Mobile" ? "font-body3" : "font-body2"
                }`}
              >
                {t("program", "blueSchool.curriculumDesc")}
              </span>
            </ProgramProcessItem>
            <ProgramProcessItem>
              <span
                className={`item__title ${
                  mode === "Mobile" ? "font-body3" : "font-body2"
                }`}
              >
                {t("program", "blueSchool.mentorTitle")}
              </span>
              <span
                className={`item__descrition ${
                  mode === "Mobile" ? "font-body3" : "font-body2"
                }`}
              >
                {t("program", "blueSchool.mentorDesc")}
              </span>
            </ProgramProcessItem>
            <ProgramProcessItem>
              <span
                className={`item__title ${
                  mode === "Mobile" ? "font-body3" : "font-body2"
                }`}
              >
                {t("program", "blueSchool.mentoringTitle")}
              </span>
              <span
                className={`item__descrition ${
                  mode === "Mobile" ? "font-body3" : "font-body2"
                }`}
              >
                {t("program", "blueSchool.mentoringDesc")}
              </span>
            </ProgramProcessItem>
          </div>
        </ProgramProcess>
      </BodyContainer>
      <Footer />
    </Container>
  );
};
const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-top: 80px;

  @media only screen and (max-width: 768px) {
    padding-top: 60px;
  }
`;

const HeaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--bg-02);
  padding-top: 80px;
  padding-bottom: 80px;

  .program__logo {
    width: 240px;
    min-width: 240px;
    max-width: 240px;
    height: 240px;
    min-width: 240px;
    max-width: 240px;
  }
  .program__title {
    color: var(--black);
    margin-top: 24px;
    margin-bottom: 16px;
  }
  .program__description {
    color: var(--grey-40);
    text-align: center;
  }

  @media only screen and (max-width: 768px) {
    padding-bottom: 60px;
    .program__logo {
      width: 117px;
      min-width: 117px;
      max-width: 117px;
      height: 117px;
      min-width: 117px;
      max-width: 117px;
    }
    .program__title {
      color: var(--black);
      margin-top: 24px;
      margin-bottom: 8px;
    }
  }
`;

const BodyContainer = styled.div`
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  margin-bottom: 160px;
`;

const ProgramDescription = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  margin-top: 100px;

  .program__description__title {
    color: var(--primary);
    margin-bottom: 24px;
  }

  @media only screen and (max-width: 768px) {
    margin-top: 40px;
    .program__description__title {
      margin-bottom: 16px;
    }
  }
`;

const ProgramProcess = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  margin-top: 100px;

  .program__process__title {
    color: var(--black);
    margin-bottom: 24px;
  }

  .program__process__row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
  }

  .program__process__list {
    width: 100%;
    border-top: 1px solid var(--grey-00);
    display: flex;
    flex-direction: column;
    margin-top: 24px;
  }
  @media only screen and (max-width: 768px) {
    margin-top: 40px;
    .program__process__title {
      margin-bottom: 16px;
    }
    .program__process__row {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
    }
  }
`;

const ProgramProcessItem = styled.div`
  width: 100%;
  padding: 32px;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid var(--grey-00);

  .item__title {
    color: var(--primary);
  }
  .item__descrition {
    color: var(--grey-60);
  }
  @media only screen and (max-width: 768px) {
    padding: 24px 16px;
  }
`;

const EmailContainer = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  .email__icon {
    width: 32px;
    height: 32px;
  }
  .email__text {
    color: var(--primary);
  }
`;
export default BlueSchool;
